import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import {
  IconCoin,
  IconCoins,
  IconFileStack,
  IconNotebook,
  IconPennant,
  IconTruck,
  IconDevicesCheck,
  IconFlag,
  IconMoneybag,
  IconBuildingWarehouse,
  IconUsers,
  IconHome,
  IconListDetails,
  IconEyeCheck,
  IconUserPlus,
} from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";

import AdminNavBar, { IMenuItem } from "../../components/AdminNavBar/AdminNavBar";
import { useStyles } from "./ProductLayout.styles";

interface IProps {
  content: ReactNode;
}

const menus: IMenuItem[] = [
  {
    label: "Dashboard",
    path: "/pm-dashboard/activenotes",
    icon: IconHome,
  },
  {
    label: "Schemes",
    path: "/schemes",
    icon: IconListDetails,
  },
  {
    label: "Campaign",
    submenu: [
      { label: "Create new", path: "/create-campaign" },
      { label: "Campaign List", path: "/campaign-list" },
    ],
    icon: IconPennant,
  },
  {
    label: "SKU",
    submenu: [
      { label: "Verify SKU Loans", path: "/verify-sku-loans" },
      { label: "Loan Details", path: "/loan-details" },
    ],
    icon: IconFileStack,
  },
  {
    label: "Note",
    submenu: [
      { label: "Create", path: "/structured-note/sku-pooling" },
      { label: "List", path: "/note-list" },
    ],
    icon: IconNotebook,
  },
  {
    label: "Issuer",
    path: "/issuer",
    icon: IconTruck,
  },
  {
    label: "User Invitation",
    path: "/user-invitation",
    icon: IconUserPlus,
  },
  {
    label: "Withdrawal",
    path: "/withdrawal",
    icon: IconCoins,
  },
  {
    label: "Virtual Accounts",
    path: "/virtual-accounts",
    icon: IconCoin,
  },

  {
    label: "External Accounts",
    path: "/external-accounts",
    icon: IconMoneybag,
  },
  {
    label: "Inventory/Orders",
    submenu: [
      { label: "Inventory", path: "/inventory" },
      { label: "Orders", path: "/orders" },
      { label: "Fund Pull", path: "/fund-pull" },
    ],
    icon: IconBuildingWarehouse,
  },
  {
    label: "Merchant Configuration",
    submenu: [{ label: "Fund Pull / Auto Refund", path: "/fund-pull-auto-refund" }],
    icon: IconUsers,
  },
  {
    label: "Audit",
    path: "/audit",
    icon: IconDevicesCheck,
  },
  {
    label: "Feature Flags",
    path: "/feature-flags",
    icon: IconFlag,
  },
  {
    label: "Request Approval",
    path: "/request-approval",
    icon: IconEyeCheck,
  },
];

const ProductLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <AdminNavBar menus={menus} userRole="Product Manager" />

      <div className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default ProductLayout;
